module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/gamepad-1-66cabba00e4134c544b684c34089e4fe.svg";